import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { KYCModal } from 'apps/auth/components/kyc/KYCModal';
import ProfileAmlLevelDocs from 'apps/auth/components/profile/aml/ProfileAmlLevelDocs';
import ProfileFieldsEditModal from 'apps/auth/components/profile/ofakim/ProfileFieldsEditModal';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { PROFILE_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_PROFILE_FIELDS_UPDATE } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const ofakimModalsList = {
    KYCModal: 'KYCModal',
    DocsList: 'DocsList',
    ProfileFieldsEdit: 'ProfileFieldsEdit',
};

export const MainOfakimHandleModal = (props) => {
    const { setNewForm, onClickNotNow, showIntro } = props;

    const { profile_form, ofakimFlowUpdateProfile, phoneCountry } = useExtra();
    const {
        buttonContinue,
        profilePurpleBlock,
        aml_level_name,
        increase_block,
        increase_sub_block,
        notificationButton,
        nextButton,
        profileHeaderTitle,
        headerGrayTitle,
    } = usePageMessages();

    const [currentModal, setCurrentModal] = useState(
        showIntro ? ofakimModalsList.KYCModal : ofakimFlowUpdateProfile ? ofakimModalsList.ProfileFieldsEdit : ofakimModalsList.DocsList,
    );

    const { profilesFields } = useSelector(({ form }) => ({
        profilesFields: form[PROFILE_FORM_NAME] && form[PROFILE_FORM_NAME].fields,
    }));

    useEffect(() => {
        if (profile_form && setNewForm) {
            const formFields = profile_form.fields.reduce((acc, el) => {
                acc[el.name] = el;
                return acc;
            }, {});
            setNewForm(PROFILE_FORM_NAME, formFields, AUTH_PROFILE_FIELDS_UPDATE);
        }
    }, [profile_form]);

    const profileFieldsSubmitHandler = (fields, json) => {
        const form = json?.forms[PROFILE_FORM_NAME];
        if (form) {
            setNewForm(PROFILE_FORM_NAME, form.fields, form.action);
        }
        setCurrentModal(ofakimModalsList.DocsList);
    };

    const getModalBody = () => {
        switch (currentModal) {
            case ofakimModalsList.KYCModal: {
                const onClickContinue = () =>
                    ofakimFlowUpdateProfile ? setCurrentModal(ofakimModalsList.ProfileFieldsEdit) : setCurrentModal(ofakimModalsList.DocsList);

                return (
                    <KYCModal
                        profilePurpleBlock={profilePurpleBlock}
                        aml_level_name={aml_level_name}
                        increase_block={increase_block}
                        increase_sub_block={increase_sub_block}
                        notificationButton={notificationButton}
                        nextButton={nextButton}
                        onClickContinue={onClickContinue}
                        onClickNotNow={onClickNotNow}
                    />
                );
            }

            case ofakimModalsList.ProfileFieldsEdit:
                return (
                    <ProfileFieldsEditModal
                        onCloseIconClick={(e) => (showIntro ? setCurrentModal(ofakimModalsList.KYCModal) : onClickNotNow(e))}
                        headerTitle={profileHeaderTitle}
                        headerGrayTitle={headerGrayTitle}
                        profilesFields={profilesFields}
                        profileForm={profile_form}
                        phoneCountry={phoneCountry}
                        buttonContinue={buttonContinue}
                        onSubmitHandler={profileFieldsSubmitHandler}
                    />
                );

            case ofakimModalsList.DocsList:
                return (
                    <ModalComponent onCloseIconClick={(e) => onClickNotNow(e)}>
                        <ProfileAmlLevelDocs />
                    </ModalComponent>
                );
            default:
                return null;
        }
    };

    return getModalBody();
};

export default MainOfakimHandleModal;
